import { takeLatest, select, call, put } from 'redux-saga/effects'
import * as ACTIONTYPES from '../constants/actiontypes'
import {
  getCurrentTime,
  getIsNeedToTrack
} from '../selectors/selectors'

import AppApiUrl from '../../api/AppApiUrl';
import { getFetch } from '../../tools/fetch'
import queryString from 'query-string';

const trackingUrl = AppApiUrl.getTrakingUrl();

/***************************** Subroutines ************************************/

function* doAfterCurrentTimeChanged() {

  const state = yield select();
  const currenSeconds = parseInt(getCurrentTime(state), 10);
  const { viewMode, tracking, activeFrame } = state;
  const {
    isViewTracked,
    secondsToNextTimeTrack,
    secondsPerTrack,
    lastTimeTrackingTime,
    framesPerTrack,
  } = tracking
  const isNeedToTrack = getIsNeedToTrack(state);
  const track = isViewTracked ? 'time' : 'view';
  const isReadMode = viewMode === 'text';
  const {
    userKey
  } = state.app;
  const guid = state.book.bookInfo.GUID;
  const now = new Date();
  const canTrackTime =
    currenSeconds >= secondsPerTrack &&
    (now - lastTimeTrackingTime) >= secondsPerTrack * 1000 &&
    (currenSeconds >= secondsToNextTimeTrack || currenSeconds <= secondsToNextTimeTrack - secondsPerTrack);

  const canTrackFrame =
    activeFrame >= framesPerTrack &&
    activeFrame % framesPerTrack === 0;

  const query = {
    track,
    guid,
    token: userKey,
  }

  const requestUrl = `${trackingUrl}?${queryString.stringify(query)}`

  if (
    !isReadMode &&
    isNeedToTrack &&
    canTrackTime
  ) {

    if (!isViewTracked) {
      yield put({
        type: ACTIONTYPES.TRACK_VIEW,
      });
    }

    yield put({
      type: ACTIONTYPES.CHANGE_SECONDS_TO_NEXT_TIME_TRACK,
      secondsToNextTimeTrack: currenSeconds + secondsPerTrack,
      lastTimeTrackingTime: new Date(),
    });

    yield call(async () => {
      const response = await getFetch(requestUrl);
      // console.log('Track time response', response);
    });
  }

  if (
    isReadMode &&
    isNeedToTrack &&
    canTrackFrame
  ) {

    if (!isViewTracked) {
      yield put({
        type: ACTIONTYPES.TRACK_VIEW,
      });
    }

    yield call(async () => {
      const response = await getFetch(requestUrl);
      // console.log('Track frame response', response);
    })
  }

}

/******************************************************************************/
/******************************* WATCHERS *************************************/
/******************************************************************************/

export default function* watchCurrentTimeChange() {
  yield takeLatest(
    [
      ACTIONTYPES.CURRENT_TIME_CHANGE,
      ACTIONTYPES.CHANGE_ACTIVE_FRAME
    ],
    doAfterCurrentTimeChanged
  )
}


// WEBPACK FOOTER //
// ./src/store/sagas/tracking.js